/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { ReminderOverlayData } from '@reminders/reminder-overlay/reminder-overlay-data';
import * as ReminderActions from '@reminders/store/reminder.actions';
import { Reminder } from '@shared/models';
import { ObjectIdPipe } from '@shared/pipes/object-id.pipe';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reminder-overlay',
    templateUrl: './reminder-overlay.component.html',
    styleUrls: ['./reminder-overlay.component.scss'],
    standalone: false
})
export class ReminderOverlayComponent implements OnDestroy {
  reminder: Reminder;
  dialogCloseSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: ReminderOverlayData,
    private store: Store<State>,
    private dialogRef: MatDialogRef<ReminderOverlayComponent>,
    private objectIdPipe: ObjectIdPipe
  ) {
    this.reminder = data.reminder;
    this.dialogCloseSubscription = this.dialogRef.beforeClosed().subscribe(
      () => this.onClose()
    );
  }

  onConfirm(): void {
    this.store.dispatch(new ReminderActions.SetReminderInactive(this.objectIdPipe.transform(this.reminder)));
  }

  onClose(): void {
    this.store.dispatch(new ReminderActions.ResumeReminder(this.objectIdPipe.transform(this.reminder)));
  }

  ngOnDestroy(): void {
    this.dialogCloseSubscription.unsubscribe();
  }
}
